<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Disciplinary Case - Sub Article</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Main Article"
              :class="classPadding"
              v-model="discSubArticle.mainArticleDesc"
              clearable
              @click:clear="clearMainArticle"
              readonly
            >
              <template slot="append">
                <v-icon @click.stop="searchMainArticle">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Ref"
              :class="classPadding"
              v-model="discSubArticle.ref"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-textarea
              label="Description"
              :class="classPadding"
              v-model="discSubArticle.desc"
              rows="1"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <!-- <list :key="componentKey">
        <template slot="actions" slot-scope="{item}">
          <v-btn @click.stop="edit(item)" text icon>
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click.stop="deleteItem(item)" text icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>-->
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>
      <!-- <router-view /> -->

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Main Article"
                  :class="classPadding"
                  v-model="editDiscSubArticle.mainArticleDesc"
                  readonly
                >
                  <!-- <template slot="append">
                    <v-icon @click.stop="searchMainArticle">mdi-magnify</v-icon>
                  </template>-->
                </v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Ref"
                  :class="classPadding"
                  v-model="editDiscSubArticle.ref"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
                <v-textarea
                  label="Description"
                  :class="classPadding"
                  v-model="editDiscSubArticle.desc"
                  rows="1"
                ></v-textarea>
              </v-col>
            </v-row>
            <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
            </v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="mainArtDialog" width="700">
        <v-card>
          <v-card-title>
            <span class="headline">Disciplinary - Main Article</span>
          </v-card-title>
          <v-card-text>
            <main-article-pagination>
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectMainArticle(item)" text outlined
                  >select</v-btn
                >
              </template>
            </main-article-pagination>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="mainArtDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Pagination from "./Pagination";
import MainArticlePagination from "../main-article/Pagination";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
// import List from "./List";
const API_ENDPOINT = "/api/discCaseSubArticle";
export default {
  metaInfo: {
    title: "Disciplinary Case - Sub Article",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    // List
    Pagination,
    MainArticlePagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    discSubArticle: {},
    componentKey: 0,
    editDiscSubArticle: {},
    editDialog: false,
    mainArtDialog: false
  }),
  methods: {
    ...mapActions("discSubArticle", ["setArticle"]),
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.discSubArticle)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      // this.editDiscSubArticle.code = rel.code;
      // this.editDiscSubArticle.desc = rel.desc;
      this.editDiscSubArticle = rel;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.discSubArticle = {};
      this.forceRerender();
      this.editDialog = false;
      this.setArticle("");
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editDiscSubArticle)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    clearMainArticle() {
      if (this.editDialog) {
        this.editDiscSubArticle.mainArticle = null;
        this.editDiscSubArticle.mainArticleDesc = null;
      } else {
        this.discSubArticle.mainArticle = null;
        this.discSubArticle.mainArticleDesc = null;
      }

      this.setArticle("");
      this.forceRerender();
    },
    searchMainArticle() {
      this.mainArtDialog = true;
    },
    selectMainArticle(item) {
      if (this.editDialog) {
        this.editDiscSubArticle.mainArticle = item.code;
        this.editDiscSubArticle.mainArticleDesc = item.desc;
      } else {
        this.discSubArticle.mainArticle = item.code;
        this.discSubArticle.mainArticleDesc = item.desc;
      }
      this.setArticle(item.code);
      this.forceRerender();
      this.mainArtDialog = false;
    }
  },
  created() {
    this.getUserAccessRights("DiscipSub");
  }
};
</script>